import React from 'react';
import ResourcePage from './ResourcePage';
import { getFarmerResource } from '../../data/farmerResources';

const FarmerSupport = () => <ResourcePage resource={getFarmerResource('farmer-support')} />;
export default FarmerSupport;
